var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.84375C10.2266 1.84375 12.9062 4.49609 12.9062 7.75C12.9062 11.0312 10.2539 13.6562 7 13.6562C3.71875 13.6562 1.09375 11.0312 1.09375 7.75C1.09375 4.49609 3.71875 1.84375 7 1.84375ZM7 0.96875C3.25391 0.96875 0.21875 4.03125 0.21875 7.75C0.21875 11.4961 3.25391 14.5312 7 14.5312C10.7188 14.5312 13.7812 11.4961 13.7812 7.75C13.7812 4.03125 10.7188 0.96875 7 0.96875ZM6.67188 4.25C6.48047 4.25 6.34375 4.41406 6.34375 4.60547L6.53516 9.19922C6.53516 9.36328 6.69922 9.5 6.86328 9.5H7.10938C7.27344 9.5 7.4375 9.36328 7.4375 9.19922L7.62891 4.60547C7.62891 4.41406 7.49219 4.25 7.30078 4.25H6.67188ZM7 10.0469C6.5625 10.0469 6.23438 10.4023 6.23438 10.8125C6.23438 11.25 6.5625 11.5781 7 11.5781C7.41016 11.5781 7.76562 11.25 7.76562 10.8125C7.76562 10.4023 7.41016 10.0469 7 10.0469Z",
    fill: "#FF3333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/ExclamationMark.6b07878bcca6a870ad601554b875c0e8.svg";
export { ForwardRef as ReactComponent };